import { GatsbyImage } from "gatsby-plugin-image";
import React from "react";
import { Btn2 } from "../common/btn";

const LoginSection = ({ data }) => {
  return (
    <div
      className="w-full py-1 px-5 border-x-0 border-t-0 border-b border-solid border-b-black/10"
      id={data.sectionId}
    >
      <div className="max-w-5xl w-full mx-auto">
        <div className="w-full flex flex-col md:flex-row items-center justify-center gap-2">
          <div>
            <GatsbyImage
              image={data.icon.asset.gatsbyImageData}
              alt={data.icon.alt}
              objectFit="contain"
              className="w-[72px] h-[72px] object-contain"
            />
          </div>
          <h2 className="text-lg md:text-2xl text-center md:text-left font-bold">
            {data.title}
          </h2>
          <div className="gap-2 flex flex-col sm:flex-row items-center md:ml-2">
            <Btn2
              data={data.button1}
              cls="py-[2px] h-auto rounded font-semibold"
            />
            <Btn2 data={data.button2} cls="py-[2px] h-auto font-semibold" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginSection;
